import { inject, Injectable } from '@angular/core';
import { LocalGtmService } from '../../../module/gtm/gtm.service.decorator';
import { LocalProduct } from './product.decorator';
import { Nexus } from '@tomandco/nexus-api-types';
@Injectable({
    providedIn: 'root'
})
export class Viewer3dService {
    private readonly gtmService = inject(LocalGtmService);

    /**
     * Returns a SafeResourceUrl for the 3D viewer iframe, or undefined if not applicable.
     * @param item The media item to check for 3D viewer eligibility.
     * @param product The product instance (for fallback SKU logic).
     */
    get3DViewerIframeSrc(item: Nexus.Lib.Catalog.Type.IProductMediaItem, product: LocalProduct<any>): string | undefined {
        if (!item.labels?.includes('3dviewer')) {
            return undefined;
        }
        // Use alt_text if available, otherwise fallback to default URL pattern
        if (item.alt_text) {
            return item.alt_text;
        }
        // Fallback URL pattern with product SKU
        const sku = product.parent?.data?.sku || '';
        if (sku) {
            return `https://configurator.v2.londondynamics.com/by_product_id/bccef8a4-6ba0-42a1-bfa0-d54184f80cec/${sku}`;
        }
        return undefined;
    }

    /**
     * Dispatches a GTM event for 3D viewer click.
     * @param product The product instance.
     * @param iframeSrc The iframe source URL (SafeResourceUrl).
     */
    dispatch3DViewerFocus(product: LocalProduct<any>, iframeSrc: string | undefined): void {
        this.gtmService.dispatchCustomEvent('3d_viewer_click', {
            sku: product.parent?.data?.sku,
            iframeSrc
        });
    }
}
